<template>
  <DashboardLayout>
    <LoggedIssuesBody
      :reversals="reversals"
      :loggedReversals="loggedReversals"
      :grandTotalReversal="grandTotalReversal"
      :totalCurrentMonthReversal="totalCurrentMonthReversal"
      :loading="loading"
    />
  </DashboardLayout>
</template>



<script>
import DashboardLayout from "@/components/Layout/DashboardLayout.vue";
import { mapState } from "vuex";
import LoggedIssuesBody from '@/components/LoggedIssues/LoggedIssuesBody.vue';
export default {
  components: {
    DashboardLayout,
    LoggedIssuesBody
  },

  computed: {
    ...mapState("reconciliation", {
      reversals: "reversals",
      loggedReversals: "loggedReversals",
      grandTotalReversal: "grandTotalReversal",
      totalCurrentMonthReversal: "totalCurrentMonthReversal",
      loading: "loading",
    }),
  },

  created() {
    this.$store.dispatch("reconciliation/fetchReversals");
    this.$store.dispatch("reconciliation/fetchLoggedReversals");
  },
};
</script>